import { require_jsx_runtime as e } from "./index21.js";
import { createContext as t, useContext as n, useEffect as r, useState as i } from "react";
//#region src/components/Provider/Locale/LocaleProvider.tsx
var a = e(), o = "user_locale/v2", s = t(void 0), c = ({ children: e, supportedLocales: t, defaultLocale: n }) => {
	let [c, l] = i(() => {
		if (typeof window < "u") {
			let e = window.localStorage.getItem(o);
			if (e && t.includes(e)) return e;
			let n = navigator.language;
			if (t.includes(n)) return n;
		}
		return n;
	}), u = (e) => {
		if (!t.includes(e)) {
			console.warn(`Locale "${e}" is not supported. Supported locales: ${t.join(", ")}`);
			return;
		}
		l(e), typeof window < "u" && window.localStorage.setItem(o, e);
	};
	r(() => {
		typeof document < "u" && (document.documentElement.lang = c);
	}, [c]);
	let d = {
		locale: c,
		setLocale: u,
		supportedLocales: t
	};
	return /* @__PURE__ */ (0, a.jsx)(s.Provider, {
		value: d,
		children: e
	});
}, l = () => {
	let e = n(s);
	if (!e) throw Error("useLocale must be used within a LocaleProvider");
	return e;
};
//#endregion
export { c as LocaleProvider, o as USER_LOCALE_KEY, l as useLocale };

//# sourceMappingURL=index605.js.map